module.exports = __webpack_public_path__ + "static/media/restaurant.9cb6e590.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Restaurant/images/restaurant.jpg
// module id = 374
// module chunks = 0